<table id="expiring-samples-table" class="custom-table">
    <thead>
        <tr>
            @for (column of columns; track column; let index = $index) {
                <th [class.centered]="column.centered" [style.min-width]="column.minWidth" [style.width]="column.width">
                    <span>{{ column.name | translate }}</span>
                </th>
            }
        </tr>
    </thead>

    @if (expiringSamplesList().length) {
        <tbody>
            @for (sample of expiringSamplesList(); track sample; let index = $index) {
                <ng-container
                    [ngTemplateOutlet]="tableRow"
                    [ngTemplateOutletContext]="{ sample: sample, rowIndex: index }">
                </ng-container>
            }
        </tbody>
    }
</table>

@if (!expiringSamplesList().length) {
    <div id="expiring-samples-empty-states-container">
        <div id="expiring-samples-empty-state">
            <app-table-empty-state
                [text1]="'dashboard.expiringSamples.emptyState.firstSentence' | translate"
                [text2]="'dashboard.expiringSamples.emptyState.secondSentence' | translate"
                [btnText]="'order.list.table.noOrdersEmptyState.createOrder' | translate"
                [btnLink]="orderSetupRoute()"
                [icon]="'fa-duotone fa-clipboard-list'">
            </app-table-empty-state>
        </div>
    </div>
}

<ng-template #tableRow let-sample="sample" let-rowIndex="rowIndex">
    <tr
        app-expiring-samples-table-row
        class="table-row"
        [class.odd]="rowIndex % 2 === 0"
        [class.even]="rowIndex % 2 === 1"
        [id]="sample.id + '-row'"
        [columns]="columns"
        [sample]="sample"></tr>
</ng-template>
